<script>
	import Wishlist from "./Wishlist.svelte";
	import Router from "svelte-spa-router";
	import Modal from './Modal.svelte';

	const routes = {
		"/": Wishlist,
		"/Wishlist/:permission": Wishlist,
	};
</script>

<style>
	main {
		text-align: center;
		padding: 1em;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

</style>

<main>
	<Modal>
	<Router {routes} />
	</Modal>
</main>
